import React, { useContext, useEffect, useState } from 'react';
import Back from '../components/Back';
import Button from '../components/Button';
import Layout from '../components/Layout';
import Select from '../components/Select';
import Steps from '../components/StepsReturning';
import Toggle from '../components/Toggle';
import UploadXml from '../components/UploadXml';
import dataSetUrls from '../constants/dataSetUrls';
import { GlobalContext } from '../reducers/global';
import langs from '../translations/langs';
import shouldShowImperial from '../api/utils/shouldShowImperial';

const ReturningUser = ({ setPage }) => {
  const {
    state: { options },
    dispatch,
  } = useContext(GlobalContext);

  const [unit, setUnit] = useState('');

  // Data sets come from language files
  const { dataSets, defaultDataSet, returning, step1 } = langs[options.language];
  const dataSetList = dataSets.map((val) => val.name);
  // if this isn't working something is wrong in the translate.json file/files
  const defaultDataSetName = dataSets.filter((val) => val.id === defaultDataSet)[0].name;

  const [dataset, setDataset] = useState(defaultDataSetName);

  useEffect(() => {
    dispatch({
      type: 'OPTIONS_UPDATE',
      dataSet: dataset,
    });
  }, [dataset, dispatch]);

  useEffect(() => {
    dispatch({
      type: 'OPTIONS_UPDATE',
      measurementSystem: unit,
    });
  }, [unit, dispatch]);

  const currentDataSetId = dataSets.filter((val) => val.name === dataset)[0].id;

  const plotManually = () => {
    setPage('step1');
  };

  const handleUpload = (xmlDataJson) => {
    if (xmlDataJson.GrowthCharts && xmlDataJson.GrowthCharts.ChildData) {
      const childData = xmlDataJson.GrowthCharts.ChildData;
      const currentDate = new Date(Date.parse(childData.BirthDate));
      dispatch({
        type: 'CHILD_UPDATE',
        sex: childData.Sex,
        birthDate: childData.BirthDate,
        birthDateYYYY: currentDate.getFullYear(),
        birthDateMM: currentDate.getMonth(),
        birthDateDD: currentDate.getDate(),
        FatherHeight: childData.FatherHeight,
        MotherHeight: childData.MotherHeight,
      });
      dispatch({
        type: 'MEASUREMENTS_SET',
        values: childData.Measures.map((val, index) => {
          const measureDate = new Date(Date.parse(val.Date));

          const inches = val.Height / 2.54;
          const feet = Math.trunc(inches / 12);
          const inch = Math.trunc(inches % 12);

          const pounds = val.Weight * 2.20462262185;
          const stone = Math.trunc(pounds / 14);
          const pound = Math.trunc(Math.round(pounds % 14));
          return {
            date: val.Date,
            dateYYYY: measureDate.getFullYear(),
            dateMM: measureDate.getMonth(),
            dateDD: measureDate.getDate(),
            height: val.Height,
            heightFt: feet,
            heightIn: inch,
            weight: val.Weight,
            weightSt: stone,
            weightLb: pound,
            selected: index === 0,
          };
        }),
      });
      setPage('returningUserSuccess');
    }
  };

  return (
    <Layout>
      <Back
        onClick={() => {
          setPage('step0');
        }}
      />
      <Steps current={1} />
      <h3>{returning.title}</h3>
      <p>{returning.returningText}</p>
      <Select
        label={step1.datasetLabel}
        name="country"
        placeholder={step1.datasetPlaceholder}
        options={dataSetList}
        value={dataset}
        setValue={setDataset}
      />
     {shouldShowImperial() &&
      <Toggle
          name="unit"
          leftVal="metric"
          leftText={step1.measurementLeftText}
          leftUnit={step1.measurementLeftUnit}
          rightVal="imperial"
          rightText={step1.measurementRightText}
          rightUnit={step1.measurementRightUnit}
          setValue={setUnit}
        />
      }
      <UploadXml
        url={dataSetUrls[currentDataSetId]}
        onSubmit={handleUpload}
        label={returning.uploadLabel}
        button={returning.uploadLabelBtn}
        lang={langs[options.language]}
      />

      <h3>{returning.nofileTitle}</h3>
      <p>{returning.nofileText}</p>
      <Button text={returning.nofileButton} onClick={plotManually} />
    </Layout>
  );
};

export default ReturningUser;
